import { render, staticRenderFns } from "./SearchView.vue?vue&type=template&id=9b716d6c&scoped=true"
import script from "./SearchView.vue?vue&type=script&lang=js"
export * from "./SearchView.vue?vue&type=script&lang=js"
import style0 from "./SearchView.vue?vue&type=style&index=0&id=9b716d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b716d6c",
  null
  
)

export default component.exports